import Icon from "@ews/react-icons";
import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Link } from "react-router-dom";
import { useGoBackOrFallback } from "../GoBack";
import { useNamedRoutes } from "../NamedRoutes";
import style from "./Header.module.scss";
import { HeaderProps } from "./types";

const Header: React.FC<HeaderProps> = ({ title, backbutton = false, id }) =>
{
    const { generate } = useNamedRoutes();
    const goBack = useGoBackOrFallback("customers");

    return <>
        <IonHeader className={style.head}>
            <IonToolbar color={'primary'} >
                <IonTitle
                    slot='start'
                    className={style.title}
                >{id ? `[${id}] ` : ""}{title}</IonTitle>

                {backbutton ?
                    <div
                        slot={'end'}
                    >
                        <Icon
                            className={style.closeBtn}
                            fill="red"
                            icon={"close"}
                            color="danger"
                            //size="large"
                            onClick={goBack} />
                    </div>
                    :
                    <Link
                        slot='end'
                        to={generate("customers")}
                        className={style.linkcloseBtn}
                    >
                        <Icon
                            fill="red"
                            icon={"close"}
                            color="danger"
                        //size="large"
                        />
                    </Link>
                }
            </IonToolbar>
        </IonHeader>
    </>;
};


export default Header;
